import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import ShortyContentInfo from "./ShortyContentInfo";
import ThumbnailBackground from "./ThumbnailBackground";

export default function ShortyThumbnail({ content, hasBeenActive }) {
  if (!content) return null;

  return (
    <Box
      sx={{
        width: { xs: "85vw", sm: "85vw", md: "400px" },
        maxWidth: "400px",
        position: "relative",
        cursor: "pointer",
        opacity: hasBeenActive ? 0.7 : 1, // Показываем что видео уже было просмотрено
        transition: "opacity 0.3s ease-in-out",
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: 0,
          width: "100%",
          paddingTop: "177.78%", // 9:16 соотношение
          overflow: "hidden",
          // borderRadius: 2,
        }}
      >
        <ThumbnailBackground content={content} />

        {/* Название видео и описание - такое же как в плеере */}
        <Box
          sx={{
            position: "absolute",
            bottom: 16,
            left: 0,
            right: 0,
          }}
        >
          <ShortyContentInfo
            content={content}
            titleVariant="h6"
            descriptionVariant="body2"
            sx={{
              px: 1,
              // Небольшой отступ справа для индикатора просмотра
              pr: { xs: 3, sm: 3, md: 1 },
            }}
          />
        </Box>

        {/* Индикатор просмотра */}
        {hasBeenActive && (
          <Box
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              width: 8,
              height: 8,
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              zIndex: 3,
            }}
          />
        )}
      </Box>
    </Box>
  );
}

ShortyThumbnail.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    sport: PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
    }),
    league: PropTypes.shape({
      title: PropTypes.string,
      name: PropTypes.string,
    }),
    teams: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        name: PropTypes.string,
      })
    ),
    date: PropTypes.string,
    verticalThumbnails: PropTypes.arrayOf(
      PropTypes.shape({
        format: PropTypes.oneOf(["DEFAULT", "MEDIUM", "HIGH", "MAXRES"]),
        url: PropTypes.string.isRequired,
        webpUrl: PropTypes.string,
      })
    ),
    thumbnails: PropTypes.arrayOf(
      PropTypes.shape({
        format: PropTypes.oneOf(["DEFAULT", "MEDIUM", "HIGH", "MAXRES"]),
        url: PropTypes.string.isRequired,
        webpUrl: PropTypes.string,
      })
    ),
  }),
  hasBeenActive: PropTypes.bool,
};
